import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "grid grid-cols-4 gap-6" };
const _hoisted_2 = {
    href: "#",
    class: "bg-white p-6 rounded-xl col-span-4 xl:col-span-1 cursor-pointer border-4 hover:border-brand-500"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = ["id"];
const _hoisted_6 = { class: "text-slate-500 font-normal text-xs" };
const _hoisted_7 = { class: "w-full text-center my-2" };
const _hoisted_8 = { class: "status-box complete" };
const _hoisted_9 = { class: "w-full" };
const _hoisted_10 = { class: "text-slate-500 font-normal text-xs my-2" };
const _hoisted_11 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_12 = { class: "mt-2" };
const _hoisted_13 = { class: "text-sm text-slate-500" };
const _hoisted_14 = { class: "font-semibold" };
const _hoisted_15 = { class: "my-loading" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ConfirmationModal = _resolveComponent("ConfirmationModal");
    const _component_Loading = _resolveComponent("Loading");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index.getData(), (schedule) => {
                return (_openBlock(), _createElementBlock("a", _hoisted_2, [
                    _createElementVNode("div", {
                        onClick: _withModifiers(($event) => (_ctx.index.navigation.toRouteName('admin.report.schedule.edit', { schedule: schedule.uuid })), ["prevent"])
                    }, [
                        (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-24 w-40 mx-auto text-slate-200",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            focusable: "false",
                            role: "img",
                            "aria-label": schedule.uuid
                        }, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                }, null, -1)
                            ]))], 8, _hoisted_4)),
                        _createElementVNode("h2", {
                            id: schedule.uuid,
                            class: "font-medium text-slate-800"
                        }, _toDisplayString(_ctx.f.ellipsis(schedule.report_name, 32)), 9, _hoisted_5),
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.f.ellipsis(schedule.report_description, 32)), 1),
                        _createElementVNode("p", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, _toDisplayString(schedule.frequency), 1),
                                _cache[1] || (_cache[1] = _createElementVNode("span", null, [
                                    _createElementVNode("span"),
                                    _createElementVNode("span")
                                ], -1))
                            ])
                        ]),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.f.formatDateShort(schedule.created_at)) + " by " + _toDisplayString(schedule.authenticatable_name), 1)
                    ], 8, _hoisted_3),
                    _createVNode(_component_ConfirmationModal, {
                        buttonClass: "btn w-full",
                        buttonText: "Delete Schedule",
                        onConfirmAction: ($event) => (_ctx.index.deleteSchedule(schedule.uuid))
                    }, {
                        default: _withCtx(() => [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-100 sm:mx-0 sm:h-10 sm:w-10" }, [
                                _createElementVNode("svg", {
                                    class: "h-6 w-6 text-brand-600",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    role: "img",
                                    focusable: "false",
                                    "aria-label": "Warning"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                    })
                                ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_11, [
                                _cache[4] || (_cache[4] = _createElementVNode("h3", {
                                    class: "text-lg leading-6 font-medium text-slate-900",
                                    id: "modal-title"
                                }, "Delete Schedule", -1)),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("p", _hoisted_13, [
                                        _cache[2] || (_cache[2] = _createTextVNode(" Are you sure you would like to delete the ", -1)),
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(schedule.report_name), 1),
                                        _cache[3] || (_cache[3] = _createTextVNode(" schedule? Doing so will prevent this report from being run automatically. ", -1))
                                    ])
                                ])
                            ])
                        ]),
                        _: 2
                    }, 1032, ["onConfirmAction"])
                ]));
            }), 256))
        ]),
        _createVNode(_component_VueEternalLoading, { load: _ctx.load }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Loading, { message: "Loading Reports" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#campaigns",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Scheduled Reports Available"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " We could not find any scheduled reports. ")
                    ], -1)
                ]))]),
            error: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load"])
    ]));
}
